export const iconFontAwesomeWeatherPooStorm = (
	<i className="fa-solid fa-poo-storm"></i>
);
